import { Badge } from "antd";
import React from "react";

export const TituloSemaforo = ({ titulo, count, icon }) => {
  return (
    <div className="semaforo__titulo">
      <span className="semaforo__titulo-texto">{icon}{titulo}</span>
      <Badge count={count} showZero overflowCount={9999} />
    </div>
  );
};
